import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header, Footer } from '../Common';
import SecondaryBanner from '@ajat/design-system/ContentBlocks/SecondaryBanner';
import Fullwidth from '@ajat/design-system/ContentBlocks/Fullwidth';
import './Ideas.css';

// All logo idea scans from the ideas asset folder, in numeric order.
const ideasContext = require.context('../../../../assets/cls-dk/ideas', false, /\.jpg$/);
const IDEA_IMAGES = ideasContext
  .keys()
  // webpack 5 lists each file twice ('./1.jpg' and '1.jpg') — keep one form
  .filter((key) => key.startsWith('./'))
  .sort((a, b) => parseInt(a.match(/\d+/)[0], 10) - parseInt(b.match(/\d+/)[0], 10))
  .map((key) => ideasContext(key));

// 4 images per row on desktop — the logo-generator banner follows the 3rd row.
const IMAGES_BEFORE_BANNER = 12;

const LOGO_GENERATOR_ROUTE = '/clothing/cls-dk/logo-generator';

const Ideas = () => {
  const navigate = useNavigate();

  const chunks = useMemo(() => [
    IDEA_IMAGES.slice(0, IMAGES_BEFORE_BANNER),
    IDEA_IMAGES.slice(IMAGES_BEFORE_BANNER),
  ].filter((chunk) => chunk.length > 0), []);

  /* Set global brand on mount, restore previous on unmount */
  useEffect(() => {
    const prev = document.documentElement.getAttribute('data-brand');
    document.documentElement.setAttribute('data-brand', 'CLS');
    return () => {
      if (prev) document.documentElement.setAttribute('data-brand', prev);
      else document.documentElement.removeAttribute('data-brand');
    };
  }, []);

  const goToLogoGenerator = (e) => {
    e.preventDefault();
    navigate(LOGO_GENERATOR_ROUTE);
  };

  return (
    <div className="ideas">
      <Header />

      <SecondaryBanner
        tag="Inspiration"
        title="Logo idéer"
      />

      <main className="ideas__wrapper">
        {chunks.map((chunk, chunkIndex) => (
          <React.Fragment key={chunkIndex}>
            <div className="ideas__grid-container">
              <div className="ideas__grid">
                {chunk.map((src, i) => (
                  <div className="ideas__item" key={chunkIndex * IMAGES_BEFORE_BANNER + i}>
                    <img
                      className="ideas__image"
                      src={src}
                      alt={`Logo idé ${chunkIndex * IMAGES_BEFORE_BANNER + i + 1}`}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Logo-generator banner once, after the 3rd row */}
            {chunkIndex === 0 && (
              <Fullwidth
                showImage={false}
                showTags={false}
                subtitle="LAV JERES EGET"
                mainCopyVariant="h2"
                mainCopy="Design jeres helt eget klasselogo på få minutter."
                additionalCopy="Brug vores logo-generator og få et unikt logo med skolens navn, klasse og destination — helt gratis."
                hyperlinkLabel="Lav et logo"
                hyperlinkHref={LOGO_GENERATOR_ROUTE}
                onHyperlinkClick={goToLogoGenerator}
              />
            )}
          </React.Fragment>
        ))}
      </main>

      <Footer />
    </div>
  );
};

export default Ideas;
